import { SVGComponentProps } from "./utils/Types"

const DeleteIcon = ({ width = 26, height = 26, className }: SVGComponentProps) => {
    return (
        <svg
            className={`text-current ${className}`}
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
        >
            <path d="M6 7V18C6 19.1046 6.89543 20 8 20H16C17.1046 20 18 19.1046 18 18V7M6 7H5M6 7H8M18 7H19M18 7H16M10 11V16M14 11V16M8 7V5C8 3.89543 8.89543 3 10 3H14C15.1046 3 16 3.89543 16 5V7M8 7H16"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default DeleteIcon
